// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"4584837c","95":"dc31de14","477":"d4ad37b9","563":"dc31de14"}[chunkId] + ".chunk.css";
};